import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { rpmEventsData } from '../mockData/rpm-events';

const RpmEventsApi = [rest.get(`${API_ROOT}rpm-events`, (req, res, ctx) => res(ctx.json(rpmEventsData)))];
export default RpmEventsApi;
